import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import siteReducer from './siteSlice';
import tenantsReducer from './tenantSlice';

export default configureStore({
    reducer: {
        // Information about the logged in user.
        user: userReducer,

        // List of tenant objects available to the user
        tenantList: tenantsReducer,

        // Information about the currently selecteed site, including a
        // list of all sites for the selected tenant.
        selectedSite: siteReducer,
    },
});